import React, { useEffect } from "react";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
    searchUserRequest,
    unfollowUserRequest,
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NotFound from "../../assets/images/NotFound.svg";
import {
    Avatar,
    ListItemText,
    Button,
    Typography,
    makeStyles,
    Grid,
    Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    primary: {
        fontSize: 12,
        fontWeight: 600,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: 85,
    },
    secondary: {
        fontSize: 12,
    },
    avatar: {
        minWidth: "unset",
        marginRight: 4,
    },
}));

export default function SuggestedUser() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useNavigate();
    const { searchedUsers, userProfile } = useSelector((state) => {
        return {
            searchedUsers: getSearchedUsers(state),
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        dispatch(searchUserRequest());
    }, []);

    return (
        <div className="mt-2 ml-1">
            <Typography
                variant="b"
                className="text-bold-center my-2"
                component="h5"
            >
                Suggested Users
            </Typography>
            <Grid container>
                {searchedUsers &&
                    searchedUsers
                        .filter((x) => x._id !== userProfile._id)
                        .slice(0, 10)
                        .map((item) => {
                            return (
                                <Grid
                                    item
                                    xs={6}
                                    sm={6}
                                    onClick={() => {
                                        dispatch(
                                            fetchOtherUserProfileRequest(
                                                item._id,
                                                history
                                            )
                                        );
                                    }}
                                >
                                    <Box
                                        textAlign="center"
                                        className="m-2"
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Avatar
                                            src={getImage(item.attachments)}
                                        />
                                        <ListItemText
                                            primary={item.fullName}
                                            secondary={
                                                "@" + item.account.userName
                                            }
                                            classes={{
                                                primary: classes.primary,
                                                secondary: classes.secondary,
                                            }}
                                        />
                                        <button
                                            className={`py-[7px] w-[100px] ${
                                                item.isFollow
                                                    ? "text-black-50"
                                                    : "bg-orange-color text-white"
                                            } rounded-lg border border-black-10 w-full text-sm font-bold  capitalize`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (item.isFollow) {
                                                    dispatch(
                                                        unfollowUserRequest({
                                                            following: item._id,
                                                        })
                                                    );
                                                } else {
                                                    dispatch(
                                                        followUserRequest({
                                                            following: item._id,
                                                        })
                                                    );
                                                }
                                            }}
                                        >
                                            {item.isFollow
                                                ? "Following"
                                                : "Follow"}
                                        </button>
                                    </Box>
                                </Grid>
                            );
                        })}
            </Grid>
            {searchedUsers && searchedUsers.length === 0 ? (
                <div className="col-lg-12 col-md-12 col-sm-12 center-div">
                    <img src={NotFound} className="img-responsive" alt="icon" />
                </div>
            ) : (
                <span />
            )}
        </div>
    );
}
